import { Button, Collapse, Divider, Form, Input } from 'antd';
import { EmailListFormComponent } from './EmailListFormComponent';
import { useEffect, useMemo } from 'react';
import type { ReactNode, RefObject } from 'react';
import { t } from 'i18next';

interface DepartmentFormComponentProps {
  departmentNames: RefObject<Array<string>>;
}

interface DepartmentFieldValue {
  departmentName?: string;
}

const validateDepartmentName = (
  departmentNames: string[],
  value: string
): Promise<void> => {
  if (value === '') {
    return Promise.resolve();
  }

  return departmentNames.filter((name) => name === value).length === 1
    ? Promise.resolve()
    : Promise.reject(new Error(t('validator.depratmentNameUsed')));
};

export const DepartmentFormComponent = ({
  departmentNames,
}: DepartmentFormComponentProps): ReactNode => {
  const watchedDepartments = Form.useWatch(['departments']);

  const departments = useMemo(
    () => (watchedDepartments as DepartmentFieldValue[] | undefined) ?? [],
    [watchedDepartments]
  );

  useEffect(() => {
    /* eslint-disable */
    departmentNames.current = departments.map(
      (department) => department?.departmentName ?? ''
    );
    /* eslint-enable */
  }, [departmentNames, departments]);

  return (
    <Form.List name={['departments']}>
      {(fields, fieldOperations) => (
        <>
          {fields.map((field) => (
            <div key={field.key}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: t('validator.departmentNameEmpty'),
                  },
                  {
                    validator: (_, value): Promise<void> => {
                      return validateDepartmentName(
                        departmentNames.current,
                        value
                      );
                    },
                  },
                ]}
                name={[field.name, 'departmentName']}
              >
                <Input placeholder={t('uniForm.depComp.name')} />
              </Form.Item>
              <Collapse
                items={[
                  {
                    key: 'Deans',
                    label: t('uniForm.depComp.deansLabel'),
                    children: (
                      <EmailListFormComponent
                        buttonTitle={t('uniForm.depComp.addDean')}
                        propertyReference="deans"
                        parentReference={[field.name]}
                        emailType={t('uniForm.depComp.deanEmailType')}
                      />
                    ),
                  },

                  {
                    key: 'Representatives',
                    label: t('uniForm.depComp.representativesLabel'),
                    children: (
                      <EmailListFormComponent
                        buttonTitle={t('uniForm.depComp.addRepresentative')}
                        propertyReference="representatives"
                        parentReference={[field.name]}
                        emailType={t('uniForm.depComp.representativeEmailType')}
                      />
                    ),
                  },
                ]}
              />
              <Divider />
            </div>
          ))}
          <Button
            style={{ margin: '1%' }}
            type="primary"
            onClick={() => {
              fieldOperations.add();
            }}
          >
            {t('uniForm.depComp.addDepartment')}
          </Button>
        </>
      )}
    </Form.List>
  );
};
